document.addEventListener("DOMContentLoaded", () => {
    const tippyPopup =  {
        init: function() {
            const popups = document.querySelectorAll('[data-tippy="tickets-popover"]');

            popups.forEach((popup) => {
                tippy(popup, {
                    content: popup.getAttribute('data-content'),
                    trigger: 'click',
                    arrow: true,
                    onTrigger(instance, event) {
                        event.stopPropagation();
                    },
                    onUntrigger(instance, event) {
                        event.stopPropagation();
                    },
                    zIndex: 200
                });
            });
        }
    };

    tippyPopup.init();
});
